
import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditProduct from "./EditProduct";
import ViewProduct from "./ViewProduct";
import DeleteProduct from "./DeleteProduct";
import { DELPRODUCT, GETPRODUCTS, SEARCHPRODUCTS } from "../../../redux/actions/productActions";
import { useDispatch, useSelector } from "react-redux";
import DataTables from "../../common/DataTables";
import { RESET_ERROR } from "../../../redux/constants/userConstants";
import { useNavigate } from 'react-router-dom'
import DataTable from "react-data-table-component";
import SearchHeader from "../../common/header_components/searchHeader";
import ImagePlaceholder from "../../../assets/images/dashboard/product/1.jpg";

const Products = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const { productlist, productdeleted, productpriceupdated, productPagination } = useSelector(state => state.product);

    const customToast = "delPro";
    console.log({ productlist })

    const [openedit, setOpenEdit] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [open, setOpen] = useState(false);
    const [value, setvalue] = useState(null)
    const [filterText, setFilterText] = useState('');
    const [datas, setDatas] = useState([])
    const [currentPage, setCurrentPage] = useState(1)


    const onOpenDeleteModal = () => {
        setOpenDelete(true);
    };

    const onCloseDeleteModal = () => {
        setOpenDelete(false);
    };
    const onOpenEditModal = () => {
        setOpenEdit(true);
    };

    const onCloseEditModal = () => {
        setOpenEdit(false);
    };

    const onOpenViewModal = () => {
        setOpenView(true);
    };

    const onCloseViewModal = () => {
        setOpenView(false);
    };
    const Capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    useEffect(() => {
        if (productlist) {
            if (filterText) {
                // Client-side filtering only when filter is applied
                let filtered = productlist.filter(ord =>
                    ord?.name?.toLowerCase().includes(filterText?.toLowerCase()) ||
                    ord?.description?.toLowerCase().includes(filterText?.toLowerCase()) ||
                    ord?.category?.name?.toLowerCase().includes(filterText?.toLowerCase()) ||
                    ord?.subCategory?.name?.toLowerCase().includes(filterText?.toLowerCase()) ||
                    ord?.units?.map(un => un?.name?.toLowerCase()).join(',').includes(filterText?.toLowerCase())
                )
                setDatas(filtered)
            } else {
                setDatas(productlist)
            }
        }
    }, [productlist, filterText])

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you wish to delete this item?")) {
            await dispatch(DELPRODUCT(id))
            // Refresh current page after deletion
            if (filterText && filterText.trim()) {
                dispatch(SEARCHPRODUCTS(filterText.trim(), currentPage))
            } else {
                dispatch(GETPRODUCTS(currentPage))
            }
        }
    }


    const handleEdit = (data) => {
        setOpen(true)
    }
    const NavigateEditpage = (id) => {
        navigate(`/products/EditProduct/${id}`);

    }


    useEffect(() => {
        if (productdeleted) {
            toast.success(" Product deleted successfully", { toastId: customToast });
            dispatch({
                type: RESET_ERROR
            })
        }
    }, [productdeleted])

    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setFilterText('');
            }
        };

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                <SearchHeader onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
            </div>
        );
    }, [filterText]);


    var columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => {
                const pageOffset = productPagination?.per_page ? (currentPage - 1) * productPagination.per_page : 0;
                return pageOffset + index + 1;
            }
        },
        {
            name: <b>{Capitalize("Image")}</b>,
            header: <b>{Capitalize("Image")}</b>,
            cell: (row, index) => {
                // Handle both array and object formats for images
                let firstImage = '';
                if (Array.isArray(row?.image)) {
                    firstImage = row.image[0];
                } else if (row?.image && typeof row.image === 'object') {
                    // Get the first image from the object
                    const imageValues = Object.values(row.image);
                    firstImage = imageValues[0] || '';
                }

                return (
                    <>
                        <span>
                            <img
                                style={{ width: 40, height: 40 }}
                                src={firstImage ? `${row?.imageBasePath}${firstImage}` : ImagePlaceholder}
                                alt="Product"
                                onError={(e) => {
                                    e.target.src = ImagePlaceholder;
                                }}
                            />
                        </span>
                    </>
                );
            }
        },
        {
            name: <b>{Capitalize("Name")}</b>,
            header: <b>{Capitalize("Name")}</b>,
            selector: row => row?.name,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("description")}</b>,
            header: <b>{Capitalize("description")}</b>,
            selector: row => row?.description === "null" ? "" : row?.description,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("category")}</b>,
            header: <b>{Capitalize("category")}</b>,
            selector: row => row?.category && row?.category?.name,
            style: {
                textAlign: "center",
            },
        },
        // {
        //     name: <b>{Capitalize("subcategory")}</b>,
        //     header: <b>{Capitalize("subcategory")}</b>,
        //     selector: row => row?.subCategory?.name && row?.subCategory?.name,
        //     style: {
        //         textAlign: "center",
        //     },
        // },
        {
            name: <b>{Capitalize("unit")}</b>,
            header: <b>{Capitalize("unit")}</b>,
            selector: row => row?.units && row?.units?.map((res) => (
                <div>
                    <span>{res?.name}</span>
                </div>

            )),
            style: {
                textAlign: "center",
            },
        },

        {
            name: <b>{Capitalize("status")}</b>,
            header: <b>{Capitalize("status")}</b>,
            selector: row => row?.status,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>Actions</b>,
            id: "delete",
            accessor: (str) => "delete",
            cell: (row, index) => (

                <>
                    <span onClick={() => handleDelete(row._id)}>

                        <i
                            className="fa fa-trash"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "#e4566e",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>
                    <span onClick={() => NavigateEditpage(row._id)}>
                        <i
                            className="fa fa-pencil"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "rgb(40, 167, 69)",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>
                </>
            )
        }
    ];




    // Handle search with debounce
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (filterText && filterText.trim()) {
                dispatch(SEARCHPRODUCTS(filterText.trim(), currentPage))
            } else {
                dispatch(GETPRODUCTS(currentPage))
            }
        }, 300) // 300ms debounce

        return () => clearTimeout(timeoutId)
    }, [filterText, currentPage, dispatch])

    // Reset to page 1 when search changes
    useEffect(() => {
        if (filterText !== undefined) {
            setCurrentPage(1)
        }
    }, [filterText])

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setCurrentPage(page)
    }

    if (!productlist) {
        return <div>Loading...</div>
    }

    return (
        <Fragment>
            <Breadcrumb title="Products List" parent="Products" />
            {/* <!-- Container-fluid starts--> */}
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5>Product Details</h5>
                                {productPagination?.total !== undefined && (
                                    <span style={{ color: '#666', fontSize: '15px' }}>
                                        (Total: <span style={{ fontWeight: 'bold', color: '#000' }}>{productPagination.total}</span> Products)
                                    </span>
                                )}
                            </CardHeader>
                            <CardBody>

                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <style>
                                        {`
                                            #basicScenario .rdt_Pagination .rdt_TableRow:first-child {
                                                display: none !important;
                                            }
                                            #basicScenario .rdt_Pagination select,
                                            #basicScenario .rdt_Pagination .rdt_TableRow select,
                                            #basicScenario .rdt_Pagination .rdt_TableRow:first-child select {
                                                display: none !important;
                                                visibility: hidden !important;
                                                opacity: 0 !important;
                                                width: 0 !important;
                                                height: 0 !important;
                                                position: absolute !important;
                                                left: -9999px !important;
                                            }
                                            #basicScenario .rdt_Pagination .rdt_TableRow:first-child * {
                                                display: none !important;
                                            }
                                            #basicScenario .rdt_Pagination .rdt_TableRow:first-child div[role="row"] {
                                                display: none !important;
                                            }
                                            #basicScenario .sc-jsJBEP,
                                            #basicScenario .svYMe,
                                            #basicScenario .sc-jsJBEP.svYMe,
                                            #basicScenario .rdt_Pagination .sc-jsJBEP,
                                            #basicScenario .rdt_Pagination .svYMe,
                                            #basicScenario .rdt_Pagination .sc-jsJBEP.svYMe {
                                                display: none !important;
                                                visibility: hidden !important;
                                                opacity: 0 !important;
                                                width: 0 !important;
                                                height: 0 !important;
                                            }
                                        `}
                                    </style>
                                    <Fragment>
                                        {productlist &&
                                            <DataTable
                                                pagination
                                                paginationServer
                                                paginationTotalRows={productPagination?.total || 0}
                                                paginationPerPage={productPagination?.per_page || 10}
                                                paginationDefaultPage={currentPage}
                                                onChangePage={handlePageChange}
                                                paginationRowsPerPageOptions={[]}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: '',
                                                    rangeSeparatorText: ' of ',
                                                }}
                                                title=""
                                                columns={columns}
                                                data={datas}
                                                fixedHeader
                                                subHeader
                                                subHeaderComponent={subHeaderComponentMemo}
                                            />}
                                    </Fragment>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>


            {/* <!-- Container-fluid Ends--> */}
        </Fragment>
    )
}

export default Products